
import { FileDown } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Progress } from "@/components/ui/progress";

interface PdfExportButtonProps {
  onExport: () => void;
  isExporting: boolean;
  exportProgress: number;
  disabled: boolean;
}

const PdfExportButton = ({ 
  onExport, 
  isExporting, 
  exportProgress, 
  disabled 
}: PdfExportButtonProps) => {
  return (
    <div className="flex flex-col gap-2">
      <Button 
        onClick={onExport} 
        variant="outline" 
        size="sm" 
        disabled={isExporting || disabled}
        className="flex items-center gap-2 whitespace-nowrap"
      >
        <FileDown className="h-4 w-4" />
        {isExporting ? "Exporting..." : "Download PDF"}
      </Button>
      
      {isExporting && (
        <div className="w-full space-y-1">
          <Progress 
            value={exportProgress} 
            className="h-1" 
          />
          <p className="text-xs text-muted-foreground text-right">
            {exportProgress < 100 ? `${Math.round(exportProgress)}%` : "Processing..."}
          </p>
        </div>
      )}
    </div>
  );
};

export default PdfExportButton;
